export DsfTextbox from "./textbox.vue";
export DsfTextarea from "./textarea.vue";

export const DsfAutoComplete=dsf.defineLazyComponent('DsfAutoComplete',()=>require('./autoComplete'));

export const DsfNumeration=dsf.defineAsyncComponent('DsfNumeration',()=>import(/*webpackChunkName:"platform_pc_form"*/'./numeration'));
export const DsfWangEditor =dsf.defineAsyncComponent('DsfWangEditor',()=>import(/*webpackChunkName:"platform_pc_form"*/'./neweditor.vue'))
export const DsfCodeEditor =dsf.defineAsyncComponent('DsfCodeEditor',()=>import(/*webpackChunkName:"platform_pc_form"*/'./codeEditor.vue'))
export const DsfUEditor = dsf.defineAsyncComponent('DsfUEditor',()=>import(/*webpackChunkName:"platform_pc_form"*/"./ueditor.vue"));
export const DsfCarnumber = dsf.defineAsyncComponent('DsfCarnumber',()=>import(/*webpackChunkName:"platform_pc_form"*/"./carNumber.vue"));

// export const DsfTextbox=Vue.defineAsyncComponent(()=>import("./textbox.vue"))